import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { OfflineBannerComponent } from './shared/components/offline-banner.component';
import { LoadingOverlayComponent } from './shared/components/loading-overlay.component';
import { AppUpdateService } from './core/services/app-update.service';
import { MinVersionGuardService } from './core/services/min-version-guard.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, OfflineBannerComponent, LoadingOverlayComponent],
  template: `
    <ion-app>
      <fsm-offline-banner />
      <ion-router-outlet></ion-router-outlet>
      <fsm-loading-overlay />
    </ion-app>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly appUpdate = inject(AppUpdateService);
  private readonly minVersionGuard = inject(MinVersionGuardService);

  ngOnInit(): void {
    void this.enforceVersionThenCheckUpdate();
  }

  /**
   * First apply the hard minimum-version gate. If it blocks (installed version
   * is below the minimum), stop here — the blocking alert is already shown and
   * the Play in-app update flow would be redundant. Otherwise, run the normal
   * Google Play update check.
   */
  private async enforceVersionThenCheckUpdate(): Promise<void> {
    const blocked = await this.minVersionGuard.enforce();
    if (blocked) {
      return;
    }
    await this.appUpdate.checkForUpdate();
  }
}
